import {
  BasePatternType,
  BasePatternTypeItem,
  buildPatternTypeConfig
} from './base-pattern-type'

export type QueuePatternType = BasePatternType

export const allQueuePatternTypes: QueuePatternType[] = ['ALL', 'ONLY']

export const queuePatternTypeConfig: Record<
  QueuePatternType,
  BasePatternTypeItem
> = buildPatternTypeConfig('detail_allQueues', 'detail_theseQueues')
